import { defineComponent as _defineComponent } from 'vue'
import { watch, shallowRef, onMounted, onBeforeUnmount } from "vue";
import { useRoute } from "vue-router";
import { $session } from "framework";
import { useAuthStore } from "@/store/auth";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props, { expose: __expose }) {
  __expose();

const route = useRoute();
const layout = shallowRef();
const authStore = useAuthStore();

function clearUserCache() {
  localStorage.removeItem("_USER_NO_");
  localStorage.removeItem("_USER_ID_");
  localStorage.removeItem("_EMAIL_");
  localStorage.removeItem("_NAME_");
  localStorage.removeItem("_USER_RESOURCE_ACCESS_");
}

async function syncUserOnResume() {
  const hasUserCache = !!localStorage.getItem("_USER_NO_");

  if (!hasUserCache) return;

  const me = await $session.fetchUserInfo();

  if (!me) {
    clearUserCache();
    authStore.setAuthenticated(false);
  }
}

function handleVisibilityChange() {
  if (document.visibilityState === "visible") {
    syncUserOnResume();
  }
}

onMounted(() => {
  document.addEventListener("visibilitychange", handleVisibilityChange);
});

onMounted(async () => {
  const ok = await $session.forceSyncUser();
  authStore.setAuthenticated(ok);
});

onBeforeUnmount(() => {
  document.removeEventListener("visibilitychange", handleVisibilityChange);
});

watch(
    () => route.meta,
    (meta) => {
      // (1) 레이아웃 처리
      layout.value = meta.layout;

      // (2) 타이틀 설정
      if (meta?.title) {
        document.title = meta.title as string;
      } else {
        document.title = "Dot Apps : Support";
      }

      // (3) favicon 설정
      if (meta?.favicon) {
        const link: HTMLLinkElement =
            document.querySelector("link[rel*='icon']") ||
            document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "icon";
        link.href = meta.favicon as string;
        document.head.appendChild(link);
      }
    },
    { immediate: true }
);

const __returned__ = { route, layout, authStore, clearUserCache, syncUserOnResume, handleVisibilityChange }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})